import React from 'react';
interface SectionTitleProps {
  title: string;
  subtitle?: string;
  alignment?: 'left' | 'center' | 'right';
  titleSize?: 'small' | 'medium' | 'large';
  withLine?: boolean;
  className?: string;
  gradient?: boolean;
}
const SectionTitle: React.FC<SectionTitleProps> = ({
  title,
  subtitle,
  alignment = 'center',
  titleSize = 'medium',
  withLine = false,
  className = '',
  gradient = true
}) => {
  const getAlignmentClass = () => {
    switch (alignment) {
      case 'left':
        return 'text-left';
      case 'right':
        return 'text-right';
      default:
        return 'text-center';
    }
  };
  const getTitleSizeClass = () => {
    switch (titleSize) {
      case 'small':
        return 'text-2xl md:text-3xl';
      case 'large':
        return 'text-4xl md:text-5xl';
      default:
        return 'text-3xl md:text-4xl';
    }
  };
  return <div className={`mb-12 ${getAlignmentClass()} ${className}`} data-id="element-246">
      <h2 className={`font-bold ${getTitleSizeClass()} ${gradient ? 'bg-gradient-to-r from-primary-600 to-secondary-600 bg-clip-text text-transparent' : 'text-gray-900'} mb-4 relative inline-block`} data-id="element-247">
        {title}
        {withLine && <span className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-primary-500 to-secondary-500 rounded-full" data-id="element-248"></span>}
      </h2>
      {subtitle && <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-249">{subtitle}</p>}
    </div>;
};
export default SectionTitle;